import Vue from 'vue'

export const state = {
  moduleSwipeSide: 'prev',
  modulePosition: {
    left: [],
    left_corner: [],
    middle: [],
    right_corner: [],
    right: []
  },
  showGarderobModuleArrow: true
}

export const getters = {
  moduleCurrent: (state, getters, rootState, rootGetters) => {
    let modulesChoose = rootGetters['modules/moduleCollectionChoose']

    if (!modulesChoose) return []

    return {
      information: modulesChoose.information,
      left: helpCurrentFunction(modulesChoose, state, 'left'),
      left_corner: helpCurrentFunction(modulesChoose, state, 'left_corner'),
      middle: helpCurrentFunction(modulesChoose, state, 'middle'),
      right_corner: helpCurrentFunction(modulesChoose, state, 'right_corner'),
      right: helpCurrentFunction(modulesChoose, state, 'right')
    }
  },

  modulesWidth: (state, getters) => {
    return getters.moduleCurrent ? getters.moduleCurrent.information.combination : 0
  }
}

export const mutations = {
  /**
   * Set module garder
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_MODULE_GARDEROB_POSITION (state, payload) {
    Vue.set(state.modulePosition[payload.type], [payload.index], payload.position)
  },

  /**
   * Clean module garderoby position
   *
   * @param state
   * @param payload
   * @constructor
   */
  RESET_MODULE_GARDEROB_POSITION (state, payload) {
    state.modulePosition = {
      left: [],
      left_corner: [],
      middle: [],
      right_corner: [],
      right: []
    }
  },

  /**
   * Set module swipe side
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_MODULE_SWIPE_SIDE (state, payload) {
    state.moduleSwipeSide = payload
  },

  /**
   * Set show module arrow
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_SHOW_MODULE_ARROW (state, payload) {
    state.showGarderobModuleArrow = payload
  }
}

export const actions = {}

function helpCurrentFunction (modulesChoose, state, key) {
  if (Array.isArray(modulesChoose[key]) && !modulesChoose[key].length) return []

  return modulesChoose[key].data.map((item, index) => {
    if (!state.modulePosition[key][index]) return item[0]
    return item[state.modulePosition[key][index]]
  })
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/moduleGarderobyCurrent.js